import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import classNames from 'classnames'
import { Error } from 'shared/ui'
import {
  useEventAttachmentUploadError,
  useEventAttachmentUploadSuccessful,
} from 'entities/Attachment'
import { useRinglessMessageFieldContext } from 'widgets/MessageFormFields/RinglessMessageField/context/ringlessMessageFieldContext'
import { RinglessMessageFieldActions } from 'widgets/MessageFormFields/RinglessMessageField/ui/RinglessMessageFieldActions/RinglessMessageFieldActions'
import { UploadingAudio } from 'widgets/MessageFormFields/RinglessMessageField/ui/UploadingAudio/UploadingAudio'
import { RinglessAudio } from 'widgets/MessageFormFields/RinglessMessageField/ui/RinglessAudio/RinglessAudio'
import { TextToSpeech } from 'widgets/TextToSpeech'
import styles from './styles.module.scss'
import { Placeholder } from './Placeholder/Placeholder'

export type IRinglessMessageFieldContent = {
  border?: 'outlined' | 'default'
}

export const RinglessMessageFieldContent = observer(
  ({ border = 'default' }: IRinglessMessageFieldContent) => {
    const {
      loadingAudio,
      onAttachmentUploadSuccessful,
      onAttachmentUploadError,
      attachment,
      textToSpeechStore,
      reset,
      error,
      isRecordAudioState,
    } = useRinglessMessageFieldContext()

    useEventAttachmentUploadSuccessful(onAttachmentUploadSuccessful)
    useEventAttachmentUploadError(onAttachmentUploadError)

    useEffect(() => reset, [])

    const isDefaultContent = !loadingAudio && !attachment && !textToSpeechStore

    const content = useMemo(() => {
      if (loadingAudio) {
        return <UploadingAudio />
      }
      if (attachment) {
        return <RinglessAudio />
      }
      if (textToSpeechStore) {
        return <TextToSpeech store={textToSpeechStore} />
      }
      return (
        <>
          <Placeholder />
          <RinglessMessageFieldActions />
        </>
      )
    }, [loadingAudio, attachment, textToSpeechStore])

    const state = isDefaultContent ? 'default' : 'card'
    return (
      <div>
        <div
          className={classNames(
            styles.wrap,
            styles[`state${state}`],
            styles[`border${border}`],
            { [styles.active]: isRecordAudioState },

            { [styles.error]: error }
          )}
        >
          {content}
        </div>
        {error && (
          <div className={styles.wrapError}>
            <Error type={'text'} error={error} />
          </div>
        )}
      </div>
    )
  }
)
